import { useSelector, useDispatch } from "react-redux";
import { toggleDropdown } from "../slices/dashboardSlice"; // Ensure correct import

const useCustomizeDash = () => {
  const dispatch = useDispatch();
  const isDropdownOpen = useSelector((state) => state.dashboard.isDropdownOpen);

  const handleToggleDropdown = (value) => {
    dispatch(toggleDropdown(value));
  };

  return { isDropdownOpen, handleToggleDropdown };
};

export default useCustomizeDash;
